import IpcRouter from '@shared/ipc/IpcRouter'

export interface BrowserSupportIpcRouterType {
  getTabs(): Promise<unknown>
  getBrowserTabContext(tabId: number): Promise<unknown>
}

class BrowserSupportIpcRouter extends IpcRouter<BrowserSupportIpcRouterType> {
  constructor() {
    super('browser-support', {
      getTabs: true,
      getBrowserTabContext: true,
    })
  }
}

export default BrowserSupportIpcRouter
